export const POLLING_RATE = 30000; //ms

export const DATE_TIME_DISPLAY_FORMAT = 'D. M. YYYY';

export const DATE_TIME_API_FORMAT = 'YYYY-MM-DD';
